import { BellIcon, ChatIcon, UserIcon } from "@heroicons/react/outline";
import { useHistory, useRouteMatch } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../database/firebase";

const HeaderRight = () => {
  let { path, url } = useRouteMatch();
  const history = useHistory();
  const [user] = useAuthState(auth);

  const goToProfile = () => {
    history.push(`${path}/profile/${user.uid}`);
  };

  return (
    <div className="flex items-center space-x-5">
      <div className="hidden lg:flex items-center space-x-5">
        <NavLink
          to={path}
          className="uppercase text-sm"
          activeStyle={{
            fontWeight: "bold",
            color: "indigo",
          }}
        >
          Home
        </NavLink>
        <NavLink
          to={`${url}/recommended`}
          activeStyle={{
            fontWeight: "bold",
            color: "indigo",
          }}
        >
          Recommended
        </NavLink>
      </div>
      <div className="flex items-center space-x-5">
        <div className="hidden lg:inline-flex space-x-5">
          <BellIcon className="header__icons" />
          <ChatIcon className="header__icons" />
        </div>
        <div className="flex items-center space-x-2">
          {user?.photoURL ? (
            <img
              src={user?.photoURL}
              alt="userimage"
              className="h-8 w-8 rounded-full cursor-pointer"
              onClick={goToProfile}
            />
          ) : (
            <UserIcon
              onClick={goToProfile}
              className="h-9 px-2 py-2 rounded-full cursor-pointer border border-gray-300 shadow"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderRight;
